import React from "react";

const IOS_APP_URL =
  "https://apps.apple.com/app/chesshood-ai-chess-trainer/id6751606749";

const ANDROID_APP_URL =
  "https://play.google.com/store/apps/details?id=com.lucas7602.chesstreining";

const appDownloadStyles = `
.appbadger {
  margin-left: 40px;
  width: 100%;
  height: auto;
}
.bgplay {
  width: 90%;
  height: auto;
}

.ch-app-section {
  width: 100%;
  padding: 4rem 1.5rem;
  background: radial-gradient(circle at top left, #222 0, #000 55%);
  color: #f8fafc;
}

/* ✅ NEW: orange border frame on the whole section */
.ch-app-frame {
  max-width: 1160px;
  margin: 0 auto;
  border: 2px solid #ff7a18;
  border-radius: 16px;
  padding: 26px;
  background: rgba(0, 0, 0, 0.35);
  box-shadow: 0 18px 50px rgba(0,0,0,0.6);
}

.ch-app-container {
  max-width: 1120px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: minmax(0, 1.3fr) minmax(0, 1fr);
  gap: 3rem;
  align-items: center;
}

.ch-app-title {
  font-size: 2.2rem;
  line-height: 1.2;
  margin-bottom: 1rem;
}

.ch-app-subtitle {
  font-size: 1rem;
  line-height: 1.6;
  max-width: 38rem;
  color: #cbd5f5;
  margin-bottom: 1rem;
}

/* ✅ NEW: extra long text */
.ch-app-longtext {
  font-size: 1rem;
  line-height: 1.7;
  max-width: 42rem;
  color: #d6d6d6;
  margin-bottom: 1.15rem;
}

/* ✅ NEW: small highlighted line */
.ch-app-highlight {
  margin-top: 10px;
  padding: 12px 14px;
  border: 1px solid rgba(255, 122, 24, 0.55);
  background: rgba(255, 122, 24, 0.08);
  border-radius: 12px;
  color: #ffd4b0;
  line-height: 1.65;
  max-width: 44rem;
}

.ch-app-badges-row {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 1.75rem;
}

.ch-store-badge img {
  height: 52px;
  display: block;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
  filter: drop-shadow(0 0 12px rgba(0, 0, 0, 0.4));
}

.ch-store-badge img:hover {
  transform: translateY(-2px) scale(1.03);
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.7);
}

.ch-app-qr-row {
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
}

.ch-qr-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: rgba(15, 23, 42, 0.8);
  padding: 0.75rem 0.9rem 1rem;
  border-radius: 0.9rem;
  border: 1px solid rgba(148, 163, 184, 0.4);
}

.ch-qr-label {
  width: 200px;
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #9ca3af;
  margin-bottom: 0.35rem;
  text-align: center;
}

.ch-qr-img {
  width: 90px;
  height: 90px;
}

.ch-app-right {
  display: flex;
  justify-content: center;
}

.ch-phone-mock {
  width: 260px;
  height: 520px;
  border-radius: 2rem;
  padding: 0.6rem;
  background: linear-gradient(145deg, #22d3ee, #6366f1, #f97316);
  box-shadow: 0 25px 60px rgba(15, 23, 42, 0.9);
}

.ch-phone-inner {
  width: 100%;
  height: 100%;
  border-radius: 1.6rem;
  background: radial-gradient(circle at top, #111827, #020617);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.ch-phone-board-placeholder {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: linear-gradient(
      45deg,
      rgba(148, 163, 184, 0.08) 25%,
      transparent 25%,
      transparent 50%,
      rgba(148, 163, 184, 0.08) 50%,
      rgba(148, 163, 184, 0.08) 75%,
      transparent 75%,
      transparent
    );
  background-size: 32px 32px;
}

.ch-phone-board-text {
  background: rgba(15, 23, 42, 0.9);
  padding: 0.6rem 0.9rem;
  border-radius: 999px;
  font-size: 0.8rem;
  border: 1px solid rgba(148, 163, 184, 0.7);
}

.ch-phone-footer {
  padding: 0.75rem 1rem 1rem;
  font-size: 0.85rem;
  color: #9ca3af;
  border-top: 1px solid rgba(31, 41, 55, 0.9);
}

/* Responsywność */
@media (max-width: 900px) {
  .ch-app-container {
    grid-template-columns: minmax(0, 1fr);
    text-align: left;
  }

  .ch-app-right {
    order: -1;
    margin-bottom: 1.5rem;
  }

  .ch-app-section {
    padding: 3rem 1.25rem;
  }

  .appbadger {
    margin-left: 0px;
  }
}

@media (max-width: 600px) {
  .ch-app-title {
    font-size: 1.7rem;
  }

  .ch-store-badge img {
    height: 46px;
  }

  .ch-phone-mock {
    width: 220px;
    height: 460px;
  }

  .ch-app-frame {
    padding: 18px;
  }
}
`;

function AppDownloadSection() {
  return (
    <>
      <style>{appDownloadStyles}</style>
      <section className="ch-app-section">
        {/* ✅ NEW: orange frame wrapper */}
        <div className="ch-app-frame">
          <div className="ch-app-container">
            <div className="ch-app-left">
              <h3 className="ch-app-title">
                Train chess online with the Chesshood app
              </h3>

              <p className="ch-app-subtitle">
                Solve AI-selected for you puzzles, practice key chess motifs,
                and improve your ELO progress. Available on iOS and Android.
              </p>

              {/* ✅ NEW: long expanded text (your idea, NOT shortened) */}
              <p className="ch-app-longtext">
                Chesshood training uses AI that adapts to the strength and
                skills of the player. It is designed in a way that the player
                solves chess puzzles and does not need to think about what they
                must improve in their chess. The AI does it instead — it
                searches what is best for the player to learn next. Thanks to
                that, the player does not need to worry and does not need to
                search what they should study. In chess there are millions of
                different topics and it is easy to get lost, learning something
                too hard or something too easy and pointless. Chesshood prevents
                that, because the AI chooses the right difficulty and the right
                training direction, step by step, based on real results.
              </p>

              <p className="ch-app-longtext">
                This is the same job a real chess trainer does — but here the AI
                replaces this work and does it automatically. The training in
                Chesshood is the most important feature and it has very advanced
                logic. It learns from the player’s results which are stored for
                analysis in the database. On top of that, Chesshood gives
                trainer comments that help from the psychological side of the
                player and suggestions that support focus, patience, confidence,
                and calm thinking. The app also has basic features for players
                who never played chess before, to learn piece moves and typical
                positions, and there is also a newer feature for checking
                openings. However, these are supporting tools — the real heart
                and power of Chesshood is the training system.
              </p>

              {/* ✅ NEW: highlight line */}
              <div className="ch-app-highlight">
                Chesshood is designed so you don’t get lost in “what to study”.
                You just train — and the AI chooses what is best for your
                progress.
              </div>

              {/* ✅ NOT TOUCHING your store section */}
              <div className="ch-app-badges-row">
                <div className="ch-qr-block">
                  <p className="ch-qr-label">Scan for iOS</p>
                  <img
                    src="/assets/app-store-badge.png"
                    alt="QR code – Chesshood on the App Store"
                    className="ch-qr-img"
                  />
                </div>

                <a
                  href={IOS_APP_URL}
                  className="ch-store-badge"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="/assets/badges/app-store-badge.svg"
                    alt="Download on the App Store"
                    className="appbadger"
                  />
                </a>

                <div className="ch-qr-block">
                  <p className="ch-qr-label">Scan for Android</p>
                  <img
                    src="/assets/chesshood-android-qr.png"
                    alt="QR code – Chesshood on Google Play"
                    className="ch-qr-img"
                  />
                </div>

                <a
                  href={ANDROID_APP_URL}
                  className="ch-store-badge"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="/assets/badges/google-play-badge.png"
                    alt="Get it on Google Play"
                    className="bgplay"
                  />
                </a>
              </div>
            </div>

            <div className="ch-app-right">
              <div className="ch-phone-mock">
                <div className="ch-phone-inner">
                  <div className="ch-phone-board-placeholder">
                    <img
                      src="/assets/screenshot_2_5_5.png"
                      alt="Chesshood app screenshot"
                      style={{
                        width: "120%",
                        height: "auto",
                        borderRadius: "0.5rem",
                        marginLeft: "2%",
                        marginTop: "0%",
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default AppDownloadSection;
